export const intensiveApiEndpointNames = ['listUsers']; // TODO - typing this `as const` would be more correct
